import { commentsSystemApi } from '@services/commentsSystemService';
import { imageHelperApi } from '@services/imageHelper';
import { versionHistoryApi } from '@services/versionHistoryService';

export const middlewares = [
  imageHelperApi.middleware,
  versionHistoryApi.middleware,
  commentsSystemApi.middleware
];
